import React, { useState, useEffect } from "react";
import { createSelector } from "reselect";

// Material UI
import { Grid, Card, CardContent, Typography, TextField, Button, IconButton, Box, InputLabel } from '@mui/material';

// Material UI Icons

import { Facebook, Google, GitHub, Twitter, Visibility, VisibilityOff } from '@mui/icons-material';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';

// Images
import logoLightFull from "../../assets/images/logo-light-full.png";
import authEffect2 from "../../assets/images/effect-pattern/auth-effect-2.png";
import authEffect from "../../assets/images/effect-pattern/auth-effect.png";

// Router
import { Link, useNavigate } from "react-router-dom";

// Formik Validation

import 'react-toastify/dist/ReactToastify.css';

// action
import {  resetRegisterFlag } from "../../slices/thunk";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Colortheme } from "../comman";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";


const Register = () => {

    document.title = "Sign Up | Rudrix";
    
    const {white75, textmuted, primary, cardbg, borderColor, textDark, cardBorder} = Colortheme();    

    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const theme: any = useTheme();


    const CustomTextField = styled(TextField)({
        '& .MuiOutlinedInput-input': {
            padding: '9px 14px',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: borderColor, // Default border color
            },
            '&:hover fieldset': {
                borderColor: borderColor, // Default border color
            },
            '&.Mui-focused fieldset': {
                border: '1px solid #a1c7ff',
                boxShadow: '0 0 0 0.25rem rgba(67,142,255,0.25)',
            },
        },
        '& .MuiInputBase-input': {
            '&::placeholder': {
                color: theme.palette.mode === 'light' ? '#000' : '#fff',
                fontSize: '14px',
            },
        },
    });
    const CustomButton = styled(Button)({
        padding: '10px 14px',
        fontSize: '14px'
    });

    const history = useNavigate();
    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Account;
    const registerdatatype = createSelector(
        selectLayoutState,
        (account) => ({
            success: account.success,
            error: account.error
        })
    );
    // Inside your component
    const {
        error, success
    } = useSelector(registerdatatype);

    useEffect(() => {
        if (success) {
            setTimeout(() => history("/login"), 3000);
        }

        setTimeout(() => {
            dispatch(resetRegisterFlag());
        }, 3000);

    }, [dispatch, success, error, history]);

    return (
        <React.Fragment>
            <Box style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: theme.palette.mode === 'light' ? '#eff2f7' : '#2b313e' }}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={7} padding={'48px 16px'}>
                        <Grid container justifyContent="center" borderRadius={'8px'} overflow={'hidden'}>
                            <Grid item xs={12} md={5} >
                                <Box sx={{ backgroundColor: cardbg, padding: '20px', height: '100%', }}>
                                    <Card sx={{
                                        backgroundColor: primary,
                                        height: '100%',
                                        borderRadius: '8px',
                                    }}>
                                        <Box sx={{ padding: { xs: '24px', md: '40px' }, height: '100%', position: 'relative' }}>
                                            <Box sx={{ height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                                                <Box>
                                                    <img src={logoLightFull} alt="rudrix" height="26" />
                                                </Box>
                                                <Box margin={'20px 0'}>
                                                    <Typography sx={{ fontSize: '26px', fontWeight: '600', marginBottom: '8px', color: '#fff' }}>Start your journey with us.</Typography>
                                                    <Typography variant="body2" sx={{ fontSize: 14, color: white75 }}>
                                                        It brings together your tasks, projects, timelines, files and more
                                                    </Typography>
                                                </Box>
                                                <Box textAlign={'center'}>
                                                    <Typography variant="body2" margin={0} sx={{ fontSize: 14, color: white75 }}>
                                                        ©{new Date().getFullYear()} Rudrix. All rights reserved.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {/* background image */}
                                            <Box sx={{ position: 'absolute', left: { xs: '-30px', md: '-26px' }, top: { xs: '-40px', md: '-40px' } }}>
                                                <img src={authEffect} alt="rudrix" />
                                            </Box>
                                            {/* circle center */}
                                            <Box>
                                                <Box sx={{ display: { xs: 'block', md: 'none' }, position: 'absolute', top: '-20px', left: '20px' }}>
                                                    <img src={authEffect2} style={{ width: '300px', height: '300px' }} alt="rudrix" />
                                                </Box>
                                                <Box sx={{ display: { xs: 'none', md: 'block' }, position: 'absolute', top: '0', right: '0', transform: 'rotate(320deg)' }}>
                                                    <img src={authEffect2} alt="rudrix" />
                                                </Box>
                                            </Box>
                                            {/* bottom image */}
                                            <Box sx={{ position: 'absolute', right: { xs: '-26px', md: '-14px' }, top: { xs: '90px', md: '72%' }, }}>
                                                <img src={authEffect} alt="rudrix" />
                                            </Box>
                                        </Box>
                                    </Card>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={7}>
                                <Card sx={{ margin: 0, border: 0, backgroundColor: cardbg, padding: '0' }} elevation={0}>
                                    <CardContent sx={{ paddingX: 0, padding: { xs: '0px', md: '48px' } }}>
                                        <Box style={{ textAlign: 'center', padding: '24px' }}>
                                            <Typography variant="h6" fontWeight={600} marginBottom={'4px'} color={primary} fontSize={20}>Create New Account</Typography>
                                            <Typography variant="body2" color={textDark}>Get your free Rudrix account now</Typography>
                                        </Box>

                                        <Box style={{ padding: '20px', marginTop: '20px' }}>
                                            <form>
                                                <Box style={{ marginBottom: '16px' }}>
                                                    <InputLabel htmlFor="email" sx={{ fontSize: '14px', fontWeight: 500, marginBottom: '8px', color: theme.palette.mode === 'light' ? '#000' : '#adb5bd' }} required >Email</InputLabel>
                                                    <CustomTextField fullWidth variant="outlined" placeholder="Enter email address" />
                                                </Box>
                                                <Box style={{ marginBottom: '16px' }}>
                                                    <InputLabel htmlFor="email" sx={{ fontSize: '14px', fontWeight: 500, marginBottom: '8px', color: theme.palette.mode === 'light' ? '#000' : '#adb5bd' }} required >Username</InputLabel>
                                                    <CustomTextField fullWidth variant="outlined" placeholder="Enter username" />
                                                </Box>
                                                <Box style={{ marginBottom: '16px' }}>
                                                    <InputLabel htmlFor="password" sx={{ display: 'inline-block', fontSize: '14px', fontWeight: 500, color: theme.palette.mode === 'light' ? '#000' : '#adb5bd' }} required>Password</InputLabel>
                                                    <Box style={{ float: 'right' }}>
                                                        <Link to="/auth-pass-reset-basic" style={{ textDecoration: 'none', color: textDark, fontSize: '14px' }} >Forgot password?</Link>
                                                    </Box>
                                                    <CustomTextField
                                                        fullWidth
                                                        autoComplete="true"
                                                        variant="outlined"
                                                        placeholder="Enter password"
                                                        type={showPassword ? 'text' : 'password'}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <IconButton onClick={handleShowPassword} edge="end">
                                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            )
                                                        }}
                                                    />
                                                </Box>
                                                <Box style={{ marginBottom: '16px' }}>
                                                    <p style={{ fontSize: 12, fontStyle: 'italic', color: textmuted, marginBottom: 0 }}>By registering you agree to the Rudrix{' '}
                                                        <Link to="#" style={{ color: primary, textDecoration: 'underline', fontStyle: 'normal', fontWeight: 'normal' }} >Terms of Use</Link>
                                                    </p>
                                                </Box>

                                                <Box style={{ marginTop: '24px' }}>
                                                    <CustomButton variant="contained" color="primary" fullWidth type="submit">
                                                        Sign Up
                                                    </CustomButton>
                                                </Box>

                                                <Box sx={{ textAlign: 'center' }}>
                                                    <Box sx={{ margin: '24px 0' }}>
                                                        <Box>
                                                            <Typography variant="body2" sx={{ fontSize: 14, marginBottom: 4, display: 'inline', backgroundColor: cardbg, padding: '0 16px' }}>Create account with</Typography>
                                                        </Box>
                                                        <Box sx={{ borderBottom: '1px solid', borderColor: cardBorder, marginTop: '-12px' }}></Box>
                                                    </Box>
                                                    <Box style={{ paddingTop: '12px', display: 'flex', justifyContent: 'center', }}>
                                                        <IconButton color="primary" disableRipple sx={{ padding: '2px' }}>
                                                            <Facebook sx={{
                                                                width: '40px', height: '40px', padding: '10px', borderRadius: '4px', backgroundColor: theme.palette.mode === 'light' ? '#ecf3ff' : '#232e43',
                                                                color: '#438eff',
                                                                '&:hover': {
                                                                    backgroundColor:
                                                                        theme.palette.mode === 'light' ? '#438eff' : '#438eff',
                                                                    color: '#fff',
                                                                    transition: 'all 0.3s ease-in-out'
                                                                },
                                                            }} />
                                                        </IconButton>
                                                        <IconButton color="error" disableRipple sx={{ padding: '2px' }}>
                                                            <Google sx={{
                                                                width: '40px', height: '40px', padding: '10px', borderRadius: '4px', backgroundColor: theme.palette.mode === 'light' ? '#fff0f0' : '#362b34',
                                                                color: '#ff6c6c',
                                                                '&:hover': {
                                                                    backgroundColor:
                                                                        theme.palette.mode === 'light' ? 'red' : '#ff6c6c',
                                                                    color: '#fff',
                                                                    transition: 'all 0.3s ease-in-out'
                                                                },
                                                            }} />
                                                        </IconButton>
                                                        <IconButton color="inherit" disableRipple sx={{ padding: '2px' }}>
                                                            <GitHub sx={{
                                                                width: '40px', height: '40px', padding: '10px', borderRadius: '4px', backgroundColor: theme.palette.mode === 'light' ? '#e7e7e8' : '#2b313e',
                                                                color: '#fff',
                                                                '&:hover': {
                                                                    backgroundColor:
                                                                        theme.palette.mode === 'light' ? '#000' : '#191c22',
                                                                    color: '#fff',
                                                                    transition: 'all 0.3s ease-in-out'
                                                                },
                                                            }} />
                                                        </IconButton>
                                                        <IconButton color="info" disableRipple sx={{ padding: '2px' }}>
                                                            <Twitter sx={{
                                                                width: '40px', height: '40px', padding: '10px', borderRadius: '4px', backgroundColor: theme.palette.mode === 'light' ? '#edf7f9' : '#24323d ',
                                                                color: '#4ab0c1',
                                                                '&:hover': {
                                                                    backgroundColor:
                                                                        theme.palette.mode === 'light' ? '#4ab0c1' : '#4ab0c1',
                                                                    color: '#fff',
                                                                    transition: 'all 0.3s ease-in-out'
                                                                },
                                                            }} />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            </form>

                                            <Box sx={{ textAlign: 'center', marginTop: "25px", marginBottom: { xs: '0', lg: '25px' } }}>
                                                <Typography variant="body2" color={textmuted}>
                                                    Don't have an account?{' '}

                                                    <Link to="/auth-signup-basic" style={{
                                                        fontWeight: '600', textDecoration: 'underline', padding: '7px',
                                                        color: '#438eff'
                                                    }}>
                                                        Signin
                                                    </Link>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default Register;
